<template>
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-header">
            Prévia do Conteúdo Publicado
            <span class="float-right" v-if="campaign">
                Última atualização {{ campaign.campaign_new.updated_at | moment('from', 'now') }}
            </span>
        </div>
        <div class="card-body pb-2">
            <div class="text-center py-5 font-weight-bold" v-if="loading">
                Carregando ...
            </div>
            <div class="text-center py-5 font-weight-bold" v-if="!campaign">
                Esperando os servidores coletarem as informações do publicador ...
            </div>

            <div class="text-center py-5 font-weight-bold" v-if="campaign && !campaign.campaign_new">
                Esperando você configurar as informações do canal para receber as notícias ...
            </div>

            <div v-if="campaign && campaign.campaign_new">
                <div class="text-center py-5 font-weight-bold" v-if="!campaign.campaign_new.json_result" >
                    Esperando que nossos servidores atualizem as notícias ...
                </div>

                <div v-if="campaign.campaign_new.json_result" >

                    <div class="row">
                        <div class="col-sm-6 mb-3" v-for="item in campaign.campaign_new.json_result.item" :key="item.id">
                            <div class="row">
                                <div class="col-md-4">
                                    <img :src="item.linkfoto" class="img-thumbnail" />
                                </div>
                                <div class="col-md-8">
                                    <h5 class="font-weight-bold">{{ item['content:encoded'] }}</h5>
                                    <p>{{ item['dc:encoded'] }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center py-5 font-weight-bold" v-if="campaign.campaign_new.json_result.item.length == 0">
                        No momento, este canal não possui notícias :(
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        campaignId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            isProcessing: false,
            campaign: null
        }
    },
    mounted() {

        // Load First
        this.load();

        // Interval for Update
        this.time = setInterval(() => {
            if(!this.isProcessing) {
                this.load(false);
            }
        }, 10000)

    },
    beforeDestroy() {
        clearInterval(this.time)
    },
    methods: {
        load(loading = true) {
            if(loading) {
                this.loading = true;
            }
            this.isProcessing = true;
            axios.get('/campaigns/' + this.campaignId + '/json')
                .then(result => {
                    this.campaign = result.data;
                    if(loading) {
                        this.loading = false;
                    }
                    this.isProcessing = false;
                })
                .catch(error => {
                    if(loading) {
                        this.loading = false;
                    }
                    this.isProcessing = false;
                })
        },
    }
}
</script>

<style>

</style>
